import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';

var BaseLogHandler = /*#__PURE__*/function () {
  function BaseLogHandler() {
    _classCallCheck(this, BaseLogHandler);
    _defineProperty(this, "nextHandler", null);
  }
  return _createClass(BaseLogHandler, [{
    key: "setNext",
    value: function setNext(handler) {
      this.nextHandler = handler;
      return handler;
    }
  }, {
    key: "handle",
    value: function handle(logLevel, message) {
      if (this.nextHandler) {
        this.nextHandler.handle(logLevel, message);
      }
    }
  }]);
}();

export { BaseLogHandler };
